// Import utils
import { getDocumentElements, setActiveStep } from '../Utils/Utils.js';

/**
 * Create the navigation for the top step.
 * 
 * @param   {object}      options 
 * 
 * @returns {object}
 */
const CreateTopStepNavigation = options => {
    const Steps = options.steps;
    const Links = getDocumentElements(options.selectors.link);
    const ActiveStepLabel = document.querySelector('.farm-calc-top-navigation__accordion-current');
    const numberLabelSelector = '.farm-calc-top-navigation__number-label';
    const textLabelSelector = '.farm-calc-top-navigation__text-label';
    const initiallyActiveLink = Links.find(link =>
        link.parentElement.classList.contains(options.classes.active)
    );

    /**
     * Set the active class on the clicked nav link’s parent,
     * and remove it from all others.
     * 
     * @param {HTMLElement} activeLink 
     * @returns {void}
     */
    const __setActiveNav = activeLink => {
        // Remove all active/completed states
        Links.forEach(link => {
            const parent = link.parentElement;
            parent.classList.remove('active', 'completed');
        });

        const parent = activeLink.parentElement;
        parent.classList.add('active');

        // Update active step label
        const stepName = parent.querySelector(textLabelSelector)?.textContent.trim();
        if (stepName && ActiveStepLabel) {
            ActiveStepLabel.textContent = stepName;
        }

        // Get the current step number
        const activeStepNum = parseInt(activeLink.getAttribute('data-step'));

        // Add .completed to all steps before the active one
        Links.forEach(link => {
            const stepNum = parseInt(link.getAttribute('data-step'));
            if (stepNum < activeStepNum) {
                link.parentElement.classList.add('completed');
            }
        });
    };

    /**
     * Bind event listeners to the links.
     * 
     * @returns {void}
     */
    const __bind  = () => {
        Links.forEach(link => {
            link.addEventListener('click', e => {
                e.preventDefault();

                // Expose the current step to the window object
                // so we can use it for the bottom navigation.
                window.currentStep = parseInt(link.getAttribute(options.attributes.step));

                setActiveStep(Steps, options.classes.active);

                __setActiveNav(link);

                // trigger bottom nav update, if available
                window.updateBottomNav?.();
            });
        });
    };

    /**
     * Setup the data-step attribute before init.
     * 
     * @returns {void}
     */
    const __mount = () => {
        Links.forEach((link, i) => {
            const Count = i + 1;
            link.setAttribute(options.attributes.step, Count);
        });
    }
    
    /**
     * Expose a function to update top nav when currentStep changes externally.
     * 
     * @returns {void}
     */
    const updateTopNav = () => {
        const current = Links.find(link => 
            parseInt(link.getAttribute(options.attributes.step)) === window.currentStep
        );
        if (current) {
            __setActiveNav(current);
        }
    };

    /**
     * Init the navigation if we have links.
     * 
     * @returns {void}
     */
    const init = () => {
        if (Links.length > 0) {
            __mount();
            __bind();
            
            window.updateTopNav = updateTopNav;
        }
    };

    /**
     * Return publicly exposed init function.
     */
    return Object.freeze({ init });
};

export default CreateTopStepNavigation;
